// @flow
import React, {PureComponent} from 'react';
import NoDataAlertMetric from './NoDataAlertMetric';
import '../alertContent.module.scss';

type PropTypes = {
  alert: Object,
  uiGroupName: string,
  getWrapperStyle: Function,
  queryParams: Object,
  isSingleLine: boolean,
  specialHeader: boolean,
};

class NoDataAlert extends PureComponent {
  props: PropTypes;

  componentDidMount() {
    const alertContentHeight = this.noDataAlertMetric.clientHeight;
    this.props.getWrapperStyle(alertContentHeight);
  }

  render() {
    const {alert, uiGroupName, queryParams, isSingleLine, specialHeader} = this.props;

    return (
      <div
        styleName="alert-content"
        ref={(c) => {
          this.noDataAlertMetric = c;
        }}
      >
        <div styleName="sep" />
        {alert.metrics.map((m) => (
          <NoDataAlertMetric
            metric={m}
            alertId={alert.id}
            uiGroupName={uiGroupName}
            startDate={m.displayStartTime}
            endDate={m.displayEndTime}
            timeScale={alert.timeScale}
            queryParams={queryParams}
            key={m.id}
            isSingleLine={isSingleLine}
            specialHeader={specialHeader}
          />
        ))}
      </div>
    );
  }
}

export default NoDataAlert;
